"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sliders = void 0;
var React = require("react");
var theme_1 = require("../../theme");
var Sliders = function (_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.colors.black : _b;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24" },
        React.createElement("defs", null,
            React.createElement("path", { id: "a", 
                // tslint:disable-next-line:max-line-length
                d: "M19 7c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1-.4-1-1s.4-1 1-1h4zM9 5c1.7 0 3 1.3 3 3s-1.3 3-3 3c-1.3 0-2.4-.9-2.8-2H5c-.6 0-1-.4-1-1s.4-1 1-1h1.2C6.6 5.9 7.7 5 9 5zM5 17c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1 .4 1 1s-.4 1-1 1H5zm14-2c.6 0 1 .4 1 1s-.4 1-1 1h-1.2c-.4 1.1-1.5 2-2.8 2-1.7 0-3-1.3-3-3s1.3-3 3-3c1.3 0 2.4.8 2.8 2H19z" })),
        React.createElement("g", { fill: color, fillRule: "evenodd" },
            React.createElement("mask", { id: "b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#a" })),
            React.createElement("g", { mask: "url(#b)" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
};
exports.Sliders = Sliders;
//# sourceMappingURL=Sliders.js.map